module.exports = __webpack_public_path__ + "static/water_glacier24-ca9da6136cbdbe3846f58bf1da9284b3.jpg";